module.exports = __webpack_public_path__ + "img/Horizons.c3b76852.png";